export default __webpack_public_path__ + "static/media/factory.9a8f4f47.jpg";